import moment from 'moment';
import React from "react";
import { Popover } from "antd";
import { useSelector } from 'react-redux';

const scaleMap = {
    million: 1_000_000,
    billion: 1_000_000_000
};
const universalSorter = (valueA, valueB, profile) => {
    const extractText = (val) => {
        if (React.isValidElement(val)) {
            val = val.props?.children ?? '';
        }
        if (Array.isArray(val)) {
            val = val.map(child => {
                if (React.isValidElement(child)) {
                    return child.props?.children ?? '';
                }
                return child;
            }).join(' ');
        }
        if (typeof val === 'number') return val;
        if (typeof val === 'string') {
            const trimmed = val.trim();
            if (profile?.dateFormate && moment(trimmed, profile.dateFormate, true).isValid()) {
                return moment(trimmed, profile.dateFormate, true).toDate().getTime();
            }
            const scaleMatch = trimmed.match(/(\d+(?:\.\d+)?)\s*(million|billion)/i);
            if (scaleMatch) {
                const number = parseFloat(scaleMatch[1]);
                const unit = scaleMatch[2].toLowerCase();
                return number * scaleMap[unit];
            }
            const cleaned = trimmed
                .replace(/^[^\d-]+/, '')
                .replace(/,/g, '')
                .replace(/\s+/g, '');
            const numberMatch = cleaned.match(/^(\d+(\.\d+)?)/);
            if (numberMatch) {
                return parseFloat(numberMatch[0]);
            }
            return trimmed.toLowerCase();
        }
        return '';
    };
    const a = extractText(valueA);
    const b = extractText(valueB);
    if (typeof a === 'number' && typeof b === 'number') {
        return a - b;
    }
    return String(a).localeCompare(String(b), undefined, { numeric: true });
};
export const generateDynamicColumns = (checkboxValues, ViewDetailPage, sortedInfo, defaultCurrency) => {
    let columns = [];
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    if (checkboxValues !== undefined) {
        columns = checkboxValues
            .filter((item) => item.isChecked)
            .map((item) => {
                const column = {
                    title: item.fieldType === "Currency" ? `${item.name} (${defaultCurrency?.currency})` : (item.fieldType === "Percentage" ? `${item.name} (%)` : item.name),
                    dataIndex: item.fieldKey,
                    key: item.fieldKey,
                    sortDirections: ['ascend', 'descend'],
                    sortOrder: sortedInfo?.column?.dataIndex === item.fieldKey ? sortedInfo?.order : null,
                };
                switch (item.FieldValue) {
                    case 'contactPerson':
                        column.onCell = () => ({
                            onClick: (e) => {
                                e.stopPropagation();
                            },
                        });
                        break;
                    case 'competition':
                        column.onCell = () => ({
                            onClick: (e) => {
                                e.stopPropagation();
                            },
                        });
                        // column.sorter = (a, b) => {
                        //     const extractText = (element) => {
                        //         return element && element.props && element.props.children !== undefined
                        //             ? String(element.props.children)
                        //             : '';
                        //     };
                        //     const contactpersonA = extractText(a[item.FieldValue]);
                        //     const contactpersonB = extractText(b[item.FieldValue]);
                        //     return contactpersonA.localeCompare(contactpersonB);
                        // };
                        // column.render = (relatedToArray) => (
                        //     <span>
                        //         {Array.isArray(relatedToArray.props.children) ? (
                        //             relatedToArray.props.children.map((item, index) => (
                        //                 <span key={index}>
                        //                     {item}
                        //                     {index !== relatedToArray.props.children.length - 1 && ', '}
                        //                 </span>
                        //             ))
                        //         ) : (
                        //             relatedToArray.props.children
                        //         )}
                        //     </span>
                        // );
                        break;
                    case 'dealOwner':
                        column.onCell = (record) => ({
                            onClick: (e) => {
                                e.stopPropagation();
                                if (Role === "Administrator" || profile.userId === record.userId) {
                                    ViewDetailPage(record.userId, "USER")
                                }
                            },
                        });
                        column.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.dealOwner.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    case 'accountName':
                        column.onCell = (record) => ({
                            onClick: (e) => {
                                e.stopPropagation();
                                if (record?.LinkAccount) {
                                    ViewDetailPage(record.accountID, "ACCOUNT")
                                }
                            },
                        });
                        column.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.accountName.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    case 'dealName':
                        column.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.dealName.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    default:
                        column.sorter = (a, b) => {
                            const valueA = a[item.FieldValue]?.props?.children || '';
                            const valueB = b[item.FieldValue]?.props?.children || '';
                            return universalSorter(valueA, valueB, profile);
                        };
                        break;
                }
                return column;
            });
    }
    return columns;
};

export const generateUsersTableData = (exportData, ViewDetailPage, checkboxValues, defaultCurrency) => {
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const usersTableData = [];
    if (exportData) {
        exportData.forEach((deal, key) => {
            const customFields = {};
            deal.customFieldValues?.forEach((attr) => {
                const fieldConfig = checkboxValues.find(
                    (field) => field.id === attr.fieldId
                );
                if (!fieldConfig) return;
                let displayValue = attr.value;
                if (fieldConfig.fieldType === "Currency") {
                    displayValue = `${defaultCurrency?.symbol} ${Number(attr.value || 0)?.toLocaleString()}`
                } else if (fieldConfig.fieldType === "Percentage") {
                    displayValue = `% ${attr.value ?? "0"}`;
                } else if (
                    (fieldConfig.fieldType === "Dropdown" || fieldConfig.fieldType === 'Multi-Dropdown')
                ) {
                    displayValue = attr.option;
                }
                customFields[fieldConfig.fieldKey] = (
                    <div className="table_list_clicks">
                        {displayValue}
                    </div>
                );
            });
            usersTableData.push({
                LinkAccount: deal.accountPermission,
                DealDataForPermission: deal,
                PipelineCheck: deal.pipelineStageName,
                SharingData: deal?.sharingPermission?.sharePermission,
                sharingid: deal.fromId,
                userId: deal.dealOwner,
                accountID: deal.account_id,
                key: deal.deals_id,
                no: key + 1,
                dealName: (<div className="user-info_image table_list_clicks">
                    {deal.deals_id &&
                        (deal.dealProfile !== null && deal.dealProfile !== undefined && deal.dealProfile !== "" ?
                            < figure >
                                <img style={{ width: "30px", height: "30px" }} src={deal.dealProfile} alt="" />
                            </figure>
                            :
                            <span className='list_span_Tag DealIcon'>
                                {deal.dealName && deal.dealName.slice(0, 1)?.toUpperCase()}
                            </span>)
                    }
                    {deal.deals_id &&
                        <figcaption>
                            <div>
                                {deal.dealName}
                            </div>
                            <div className='entityemail'>
                                {deal.pipelineStageName}
                            </div>
                        </figcaption >
                    }
                </div >),
                dealOwner: (<div className={`user-info_image ${(Role === "Administrator" || profile.userId === Number(deal.dealOwner)) && "ListNavigate"}`}>
                    {deal.dealOwner &&
                        (deal.userProfilePic !== null && deal.userProfilePic !== undefined && deal.userProfilePic !== "" ?
                            < figure >
                                <img style={{ width: "30px", height: "30px" }} src={deal.userProfilePic} alt="" />
                            </figure>
                            :
                            <span className='list_span_Tag UserIcon'>
                                {deal.userFirstName && deal.userFirstName.slice(0, 1)?.toUpperCase()}
                            </span>)
                    }
                    {deal.dealOwner &&
                        <figcaption>
                            <div>
                                {`${deal.userFirstName} ${deal.userLastName}`}
                            </div>
                            <div className='entityemail'>
                                {deal.dealOwnerEmail}
                            </div>
                        </figcaption>
                    }
                </div>),
                accountName: (<div className={`user-info_image ${deal.accountPermission && "ListNavigate"}`}>
                    {deal.account_id &&
                        (deal.accountProfile !== null && deal.accountProfile !== undefined && deal.accountProfile !== "" ?
                            < figure >
                                <img style={{ width: "30px", height: "30px" }} src={deal.accountProfile} alt="" />
                            </figure>
                            :
                            <span className='list_span_Tag AccountIcon'>
                                {deal.accountOriginalName && deal.accountOriginalName.slice(0, 1)?.toUpperCase()}
                            </span>)
                    }
                    {deal.account_id &&
                        <figcaption><div>
                            {deal.accountOriginalName}
                        </div>
                            <div className='entityemail'>
                                {deal.accountNumber}
                            </div>
                        </figcaption>
                    }
                </div>),
                competition: (
                    <div className='table_list_clicks' style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: "nowrap", // Keeps all items in a row
                        minWidth: "max-content", // Ensures it grows as needed
                    }}>
                        {deal.competitiondata && deal.competitiondata.length > 0 && (
                            <>
                                {deal.competitiondata.slice(0, 3).map((item, index) => {
                                    if (!item.competitionName) {
                                        return null;
                                    }
                                    const EntiryIds = item?.competitionId
                                    const permission = item.competitionPermission
                                    return (
                                        <div
                                            title={item?.competitionName}
                                            key={index}
                                            role="button"
                                            tabIndex={0}
                                            style={{ cursor: !permission && "not-allowed" }}
                                            onKeyDown={(event) => {
                                                if (permission && (event.key === 'Enter' || event.key === ' ')) {
                                                    ViewDetailPage(EntiryIds, "ACCOUNT")
                                                }
                                            }}
                                            onClick={permission ? () => ViewDetailPage(EntiryIds, "ACCOUNT") : undefined}
                                        >
                                            {item?.competitionProfile ? (
                                                <span className="image_icon OverLap_images">
                                                    <img style={{
                                                        width: '30px',
                                                        height: '30px',
                                                        borderRadius: '50%',
                                                    }}
                                                        src={item?.competitionProfile} alt="" />
                                                </span>
                                            ) : (
                                                <span className="image_icon OverLap_images AccountIcon" >
                                                    {item?.competitionName.slice(0, 1)?.toUpperCase()}
                                                </span>
                                            )}
                                        </div>);
                                })}
                                {deal.competitiondata.length > 3 && (
                                    <Popover
                                        placement="bottomLeft"
                                        trigger="hover"
                                        content={
                                            <div
                                                style={{
                                                    maxHeight: "200px",
                                                    overflowY: "auto",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "8px",
                                                    padding: "4px 0",
                                                }}
                                            >
                                                {deal.competitiondata.slice(3).map((item, index) => {
                                                    if (!item.competitionName) {
                                                        return null;
                                                    }
                                                    const EntiryIds = item?.competitionId
                                                    const permission = item.competitionPermission
                                                    return (
                                                        <div
                                                            title={item?.competitionName}
                                                            key={index}
                                                            role="button"
                                                            tabIndex={0}
                                                            style={{ cursor: permission ? "pointer" : "not-allowed", display: "flex", alignItems: "center", gap: "8px", marginBottom: 10 }}
                                                            onKeyDown={(event) => {
                                                                if (permission && (event.key === 'Enter' || event.key === ' ')) {
                                                                    ViewDetailPage(EntiryIds, "ACCOUNT")
                                                                }
                                                            }}
                                                            onClick={permission ? () => ViewDetailPage(EntiryIds, "ACCOUNT") : undefined}

                                                        >
                                                            {item?.competitionProfile ? (
                                                                <img
                                                                    src={item?.competitionProfile}
                                                                    alt={item?.competitionName}
                                                                    style={{
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        borderRadius: '50%',
                                                                    }}
                                                                />
                                                            ) : (
                                                                <span className="image_icon AccountIcon">
                                                                    {item?.competitionName.slice(0, 1)?.toUpperCase()}
                                                                </span>
                                                            )}
                                                            <span>{item?.competitionName}</span>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        }
                                    >
                                        <span
                                            style={{
                                                marginLeft: "25px",
                                                fontSize: "13px",
                                                fontWeight: 500,
                                                color: "#1677ff",
                                                cursor: "pointer",
                                            }}
                                        >
                                            +{deal.competitiondata.length - 3} more
                                        </span>
                                    </Popover>
                                )}
                            </>
                        )}
                    </div>
                ),
                contactPerson: (
                    <div className='table_list_clicks' style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: "nowrap", // Keeps all items in a row
                        minWidth: "max-content", // Ensures it grows as needed
                    }}>
                        {deal.contactNames && deal.contactNames.length > 0 && (<>
                            {deal.contactNames.slice(0, 3).map((item, index) => {
                                const permission = item.contactPersonPermission
                                return (
                                    <div
                                        title={item?.contactPersonName}
                                        key={index}
                                        role="button"
                                        tabIndex={0}
                                        style={{ cursor: !permission && "not-allowed" }}
                                        onKeyDown={(event) => {
                                            if (permission && (event.key === 'Enter' || event.key === ' ')) {
                                                ViewDetailPage(item?.contactPersonId, "CONTACT")
                                            }
                                        }}
                                        onClick={permission ? () => ViewDetailPage(item?.contactPersonId, "CONTACT") : undefined}
                                    >
                                        {item?.contactPersonProfileic ? (
                                            <span className="image_icon OverLap_images">
                                                <img style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    borderRadius: '50%',
                                                }}
                                                    src={item?.contactPersonProfileic} alt="" />
                                            </span>
                                        ) : (
                                            <span
                                                className="image_icon OverLap_images ContactIcon"
                                            // style={{
                                            //     display: 'inline-block',
                                            //     width: '30px',
                                            //     height: '30px',
                                            //     borderRadius: '50%',
                                            //     backgroundColor: '#FFA500', // Or any fallback color
                                            //     textAlign: 'center',
                                            //     lineHeight: '30px',
                                            //     fontSize: '14px',
                                            //     fontWeight: 'bold',
                                            // }}
                                            >
                                                {item?.contactPersonName.slice(0, 1)?.toUpperCase()}
                                            </span>
                                        )}
                                    </div>
                                );
                            })}
                            {deal.contactNames.length > 3 && (
                                <Popover
                                    placement="bottomLeft"
                                    trigger="hover"
                                    content={
                                        <div
                                            style={{
                                                maxHeight: "200px",
                                                overflowY: "auto",
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "8px",
                                                padding: "4px 0",
                                            }}
                                        >
                                            {deal.contactNames.slice(3).map((item, index) => {
                                                const permission = item.contactPersonPermission
                                                return (<div
                                                    title={item?.contactPersonName}
                                                    key={index}
                                                    role="button"
                                                    tabIndex={0}
                                                    style={{ cursor: permission ? "pointer" : "not-allowed", display: "flex", alignItems: "center", gap: "8px", marginBottom: 10 }}
                                                    onKeyDown={(event) => {
                                                        if (permission && (event.key === 'Enter' || event.key === ' ')) {
                                                            ViewDetailPage(item?.contactPersonId, "CONTACT")
                                                        }
                                                    }}
                                                    onClick={permission ? () => ViewDetailPage(item?.contactPersonId, "CONTACT") : undefined}
                                                >
                                                    {item?.contactPersonProfileic ? (
                                                        <img
                                                            src={item?.contactPersonProfileic}
                                                            alt={item?.contactPersonName}
                                                            style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                borderRadius: '50%',
                                                            }}
                                                        />
                                                    ) : (
                                                        <span className="image_icon ContactIcon">
                                                            {item?.contactPersonName.slice(0, 1)?.toUpperCase()}
                                                        </span>
                                                    )}
                                                    <span>{item?.contactPersonName}</span>
                                                </div>
                                                )
                                            })}
                                        </div>
                                    }
                                >
                                    <span
                                        style={{
                                            marginLeft: "25px",
                                            fontSize: "13px",
                                            fontWeight: 500,
                                            color: "#1677ff",
                                            cursor: "pointer",
                                        }}
                                    >
                                        +{deal.contactNames.length - 3} more
                                    </span>
                                </Popover>
                            )}
                        </>
                        )}
                    </div>
                ),
                parentDealId:<></>,
                priority: (<div className={`table_list_clicks status-text Task${deal.priority}`}>{deal.priorityName}</div>),
                dealType: (<div className='table_list_clicks'>{deal.dealTypeName}</div>),
                subtype: (<div className='table_list_clicks'>{deal.subTypeName}</div>),
                commitStatus: (<div className='table_list_clicks'>{deal.commitStatusName}</div>),
                pipelineStage: (<div className={`table_list_clicks status-text PipeLine${deal.pipelineStage}`}>{deal.pipelineStageName}</div>),
                expectedDealLength: (<div className='table_list_clicks'>{deal.expectedDealLength !== undefined && deal.expectedDealLength !== null && `% ${deal.expectedDealLength}`}</div>),
                winProbability: (<div className='table_list_clicks'>{deal.winProbability !== undefined && deal.winProbability !== null && `% ${deal.winProbability}`}</div>),
                forecastedValue: (<div className='table_list_clicks'>{`${defaultCurrency?.symbol} ${deal?.forecastedValue?.toLocaleString()}`}</div>),
                dealValue: (<div className='table_list_clicks'>{`${defaultCurrency?.symbol} ${deal?.dealValue?.toLocaleString()}`}</div>),
                dealProfit: (<div className='table_list_clicks'>{`${defaultCurrency?.symbol} ${deal?.dealProfit?.toLocaleString()}`}</div>),
                grossDealValue: (<div className='table_list_clicks'>{`${defaultCurrency?.symbol} ${deal?.grossDealValue?.toLocaleString()}`}</div>),
                discountPercentage: (<div className='table_list_clicks'>{deal.discountPercentage !== undefined && deal.discountPercentage !== null && `% ${deal.discountPercentage}`}</div>),
                created_at: (<div className='table_list_clicks'>{deal?.created_at}</div>),
                modified_at: (<div className='table_list_clicks'>{deal?.modified_at}</div>),
                revenueStartDate: (<div className='table_list_clicks'>{deal?.revenueStartDate}</div>),
                revenueEndDate: (<div className='table_list_clicks'>{deal?.revenueEndDate}</div>),
                expectedClosureDate: (<div className='table_list_clicks'>{deal?.expectedClosureDate}</div>),
                dealWonReason: (<div className='table_list_clicks'>{deal.dealWonReasonName}</div>),
                dealLostReason: (<div className='table_list_clicks'>{deal.dealLostReasonName}</div>),
                dealHoldReason: (<div className='table_list_clicks'>{deal.dealHoldReasonName}</div>),
                actualDealMargin: (<div className='table_list_clicks'>{deal.actualDealMargin !== undefined && deal.actualDealMargin !== null && `% ${deal.actualDealMargin}`}</div>),
                dealRestartDate: (<div className='table_list_clicks'>{deal?.dealRestartDate}</div>),
                dealHoldDate: (<div className='table_list_clicks'>{deal?.dealHoldDate}</div>),
                actualCloserDate: (<div className='table_list_clicks'>{deal?.actualCloserDate}</div>),
                dealLostDate: (<div className='table_list_clicks'>{deal?.dealLostDate}</div>),
                dealDescription: (<div className='table_list_clicks'>
                    {deal.dealDescription ? `${deal.dealDescription.substring(0, 50)}...` : deal.dealDescription}
                </div>),
                deal_score: (
                    <div className='table_list_clicks'>
                        {Number(deal?.deal_score)?.toFixed(2)}
                    </div>
                ),
                ...customFields,
            });
        });
    }
    return usersTableData;
};
